export const iconFontAwesomeMedicalHealthHeadSideVirus = (
	<i className="fa-solid fa-head-side-virus"></i>
);
